module.exports = __webpack_public_path__ + "static/media/IRMM.21edb76e.png";